export enum DailyColumnType {
  Metrics = 'Metrics',
  One = '1',
  Two = '2',
  Three = '3',
  Four = '4',
  Five = '5',
  Six = '6',
  Seven = '7',
  Eight = '8',
  Nine = '9',
  Ten = '10',
  Eleven = '11',
  Twelve = '12',
  Thirteen = '13',
  Fourteen = '14',
  Fifteen = '15',
  Sixteen = '16',
  Seventeen = '17',
  Eighteen = '18',
  Nineteen = '19',
  Twenty = '20',
  TwentyOne = '21',
  TwentyTwo = '22',
  TwentyThree = '23',
  TwentyFour = '24',
  Total = 'Total',
}

export enum WeeklyColumnType {
  Metrics = 'Metrics',
  Sunday = 'sun',
  Monday = 'mon',
  Tuesday = 'tue',
  Wednesday = 'wed',
  Thursday = 'thu',
  Friday = 'fri',
  Saturday = 'sat',
  Total = 'Total',
}

// Helper: Ordered day keys
export const WeekDayOrder: WeeklyColumnType[] = [
  WeeklyColumnType.Sunday,
  WeeklyColumnType.Monday,
  WeeklyColumnType.Tuesday,
  WeeklyColumnType.Wednesday,
  WeeklyColumnType.Thursday,
  WeeklyColumnType.Friday,
  WeeklyColumnType.Saturday,
];
